import { akeronService } from "./akeronService";

const section = "Product";

function filter(name = " ", from = "0", limit = "10", active = "1") {
  return akeronService.make_get_request(`${section}/ListProduct/${name}/${from}/${limit}/${active}`, {}).then((response) => {
    let result = {
      quantity: response.quantity || 0,
      list: response.products || response.list || [],
    };
    return result;
  });
}

function getAll() {
  return akeronService.make_get_request(`${section}/ListAll`, {}).then((response) => {
    return response.products || response.list || [];
  });
}

function remove(id) {
  return akeronService.make_delete_request(`${section}/DeleteProduct/${id}`, {});
}

function create(item) {
  const param = {
    Name: item.name,
    FamilyId: item.family.id,
  };
  return akeronService.make_post_request(`${section}/CreateProduct`, param);
}

function update(item) {
  const param = {
    id: item.id,
    Name: item.name,
    FamilyId: item.family.id,
    IsActive: item.isActive !== undefined ? item.isActive : true,
  };
  return akeronService.make_put_request(`${section}/UpdateProduct`, param);
}

export const productoService = {
  getAll,
  filter,
  remove,
  create,
  update,
};
